// extracted by mini-css-extract-plugin
export default {"root":"_2_Zhx","compact":"_2PDy0","priority-primary":"_3Pyq_","priorityPrimary":"_3Pyq_","disabled":"O2-nc","priority-secondary":"_13lM0","prioritySecondary":"_13lM0"};